import * as React from 'react';

function SvgVerifed(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.531 9.22a.75.75 0 010 1.061l-4.5 4.5a.751.751 0 01-1.062 0l-2.25-2.25a.752.752 0 011.062-1.062l1.719 1.72 3.969-3.97a.75.75 0 011.062 0z"
      />
      <path d="M15.41 3.77l-1.382-1.417L15.1 1.306l.933.956 1.335-.017a4.335 4.335 0 014.386 4.386l-.015 1.335.954.933a4.336 4.336 0 010 6.201l-.955.933.016 1.335a4.338 4.338 0 01-4.386 4.386l-1.335-.015-.933.954a4.334 4.334 0 01-6.2 0l-.934-.955-1.335.016a4.336 4.336 0 01-4.386-4.386l.015-1.335-.954-.933a4.336 4.336 0 010-6.2l.956-.934-.017-1.335a4.335 4.335 0 014.386-4.386l1.335.015.933-.954a4.335 4.335 0 016.201 0l-1.072 1.047a2.835 2.835 0 00-4.056 0L8.592 3.77l-1.98-.024a2.835 2.835 0 00-2.867 2.868L3.77 8.59 2.353 9.972a2.835 2.835 0 000 4.056l1.416 1.38-.024 1.98a2.835 2.835 0 002.868 2.866l1.977-.024 1.382 1.416a2.834 2.834 0 004.056 0l1.38-1.416 1.98.024a2.835 2.835 0 002.866-2.868l-.024-1.977 1.416-1.381a2.836 2.836 0 000-4.056l-1.416-1.38.024-1.98a2.835 2.835 0 00-2.868-2.867l-1.977.024z" />
    </svg>
  );
}

export default SvgVerifed;
